import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../cards/BasicCard/BasicCard.vue.js';
import { usePortalStore } from '../../../store/portal/index.js';
import { formatPatientDataOnTube } from '../../../../TubeLabelingExample/helpers.js';
import __vue_component__$1 from '../../../../TubeLabelingExample/TubeLabelingExample.vue.js';
import '../../../store/portal/sessionStore.js';
import '@caresend/utils';
import '@caresend/types';
import 'file-saver';
import '../../../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../../../store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../../../../database/firebaseConfig/init.js';
import '../../../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../ui/Icon.vue.js';
import '../../../../../../functions/configuration/icons.js';
import '../../../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../../../functions/tracking/index.js';
import '../../../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../../../../router/routes/dev/model.js';
import '../../../../../../router/routes/dev/routes.js';
import '../../../../../../router/routes/dashboard/model.js';
import '../../../../../../router/routes/pro/model.js';
import '../../../../../../router/routes/visitsPage/model.js';
import '../../../../../../router/routes/orderFlow/model.js';
import '../../../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../../../router/routes/orderFlow/routes.js';
import '../../../../../../router/routes/schedulingFlow/model.js';
import '../../../../../../router/routes/schedulingFlow/routes.js';
import '../../../../../../router/routes/chartingFlow/model.js';
import '../../../../../../router/routes/chartingFlow/routes.js';
import '../../../../../../router/routes/portal/portalRoutes.js';
import '../../../../../../router/routes/portal/model.js';
import '../../../../../../router/routes/visitsPage/routes.js';
import '../../../../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../../../store/modules/chartingFlow/model.js';
import '../../../../../../store/modules/office/index.js';
import '../../../../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../../../../store/modules/office/model.js';
import '../../../../../../store/modules/orderFlow/index.js';
import '../../../../../../store/modules/procedures/model.js';
import '../../../../../../store/modules/schedulingFlow/index.js';
import '../../../../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'ItineraryWaypointFollowKitInstructions',
    components: {
        BasicCard: __vue_component__,
        TubeLabelingExample: __vue_component__$1,
    },
    props: {
        waypointActionID: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const portalStore = usePortalStore();
        const store = getStore();
        const patientData = computed(() => {
            var _a;
            const id = (_a = portalStore.waypointActions.get(props.waypointActionID)) === null || _a === void 0 ? void 0 : _a.computed.singlePatientID;
            const patient = store.getters['users/getUserByID'](id);
            return formatPatientDataOnTube(patient);
        });
        return {
            patientData,
        };
    },
});

export { script as default };
